module.exports = __webpack_public_path__ + "static/media/qiye.b2187f3.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/qiye.mp4
// module id = 6QqS
// module chunks = 10